import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { parseToArray } from '../../../../../parseUtils';
import { faireBaseUrl } from '@faire/web--source/common/routes/faireBaseUrl';
import { compile } from 'path-to-regexp';
import qs from 'query-string';
(function(QueryParameters) {
    QueryParameters.build = function(partial) {
        return partial;
    };
    function parse() {
        var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
        var rawParsed = typeof search === 'string' ? qs.parse(search) : search !== null && search !== void 0 ? search : {};
        var parsed = _object_spread({}, rawParsed);
        parsed['filters'] = parseToArray(rawParsed['filters']);
        return parsed;
    }
    /**
   * Parse the given raw query string or partially-parsed react-router-dom queryParams object.
   */ QueryParameters.parse = parse;
})(QueryParameters || (QueryParameters = {}));
/**
 * Generated from Jersey path "/category/{c1CategoryUrlId}/brand-value/{brandValue}"
 *
 * Product Area: CATEGORY_RESULTS
 */ export var route = '/category/:c1CategoryUrlId/brand-value/:brandValue';
export var props = {
    path: route,
    templatedPath: '/category/{c1CategoryUrlId}/brand-value/{brandValue}',
    productArea: 'CATEGORY_RESULTS',
    pod: 'FAIRE_POD_BROWSE',
    pillar: 'FAIRE_PILLAR_DISCOVERY'
};
export var toPath = compile(route, {
    encode: encodeURIComponent
});
export function path(c1CategoryUrlId, brandValue, queryParams) {
    var compiledPath = toPath({
        c1CategoryUrlId: c1CategoryUrlId,
        brandValue: brandValue
    });
    var queryString = queryParams ? qs.stringify(queryParams) : '';
    return "".concat(compiledPath).concat(queryString ? "?".concat(queryString) : '');
}
/**
 * Build a full URL of the route (including the base faire URL).
 */ export var url = function(c1CategoryUrlId, brandValue, queryParams) {
    return faireBaseUrl(3000) + path(c1CategoryUrlId, brandValue, queryParams);
};
export default path;
export var QueryParameters;
